export const scrollToId = (hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -84, duration: 1.2 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export const handleAnchorClick = (e, hash, after) => {
    e.preventDefault();
    scrollToId(hash);
    if (after) after();
};
